import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import Game from '@/pages/game';
import Level from '@/pages/level';
import Mine from '@/pages/mine';
import { switchTab } from './platform';
import '@/app.scss';
import './browser.css';
const route = () => ['game', 'level', 'mine'].includes(location.hash.slice(1)) ? location.hash.slice(1) : 'game';
function App() {
  const [page, setPage] = useState(route);
  const [, resize] = useState(0);
  useEffect(() => {
    const change = () => setPage(route());
    const size = () => resize(n => n + 1);
    addEventListener('hashchange', change); addEventListener('resize', size);
    return () => { removeEventListener('hashchange', change); removeEventListener('resize', size); };
  }, []);
  return <div className='web-shell'>
    <header className='web-header'><span>🐑 羊了个羊</span><small>网页版</small></header>
    <main className='app-main'>{page === 'mine' ? <Mine /> : page === 'level' ? <Level /> : <Game />}</main>
    <nav className='web-tabs' aria-label='主导航'>
      {[['game', '▦', '游戏'], ['level', '⚑', '关卡'], ['mine', '◉', '我的']].map(([id, icon, name]) => <button key={id} aria-label={name} aria-current={page === id ? 'page' : undefined} className={page === id ? 'active' : ''}
        onClick={() => { if (page !== id) switchTab({ url: '/pages/' + id + '/index' }); }}
      ><span>{icon}</span>{name}</button>)}
    </nav>
  </div>;
}
createRoot(document.getElementById('root')!).render(<App />);
